import React, { useEffect, useRef } from "react";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import { Email, Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import WatsAppIcon from "../../../atoms/icons/WatsAppIcon";
import MessengerIcon from "../../../../../assets/images/messenger.svg";
import LauncherIcon from "../../../../../assets/images/launcher.svg";
import Youtube from "../../../layouts/footer/DefaultFooter/Youtube";
import Instagram from "../../../layouts/footer/KishoraloFooter/Instagram";
import { CloseIcon } from "../../../basic/icons/close-icon";

import "./verticalMenubar.m.css";
import { getDateFromUtils } from "../../../utils/utils";

const VerticalMenubar = ({
  isDesktop,
  toggleVerticalMenubar,
  hamburgerMenu,
  domainSlug = "",
  socialLinks,
  lang,
  customSocialLinks,
}) => {
  const socialShareLinks = customSocialLinks[domainSlug] || socialLinks;
  const ref = useRef(null);
  const homeMenuItem = [
    {
      title: lang === "en" ? "Home" : "প্রচ্ছদ",
      completeUrl: "/",
    },
  ];

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      toggleVerticalMenubar();
    }
  };

  useEffect(() => {
    ref.current.classList.remove("preload");

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      toggleVerticalMenubar();
    };
  });

  return (
    <div styleName="vertical-menubar-wrapper" className="vertical-menubar-wrapper">
      <div styleName={`close`} className="button-close">
        <CloseIcon color="#ffffff" width={30} height={30} />
      </div>
      <div ref={ref} className="vertical-menubar preload" styleName="vertical-menubar slide-in">
        {!isDesktop && <time styleName="date">{getDateFromUtils(lang)}</time>}
        {!isDesktop && <NavbarSearch lang={lang} />}
        <Navbar menu={homeMenuItem} toggleVerticalMenubar={toggleVerticalMenubar} />
        <Navbar menu={hamburgerMenu} toggleVerticalMenubar={toggleVerticalMenubar} />
        <div styleName="bottom-container">
          <div styleName="social-share-icons">
            {socialShareLinks["facebook-url"] && (
              <Link
                aria-label="Facebook Link"
                href={socialShareLinks["facebook-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </Link>
            )}
            {socialShareLinks["twitter-url"] && (
              <Link
                aria-label="Twitter Link"
                href={socialShareLinks["twitter-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </Link>
            )}
            {socialShareLinks["messenger-url"] && (
              <Link
                aria-label="Messenger Link"
                href={socialShareLinks["messenger-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`${assetify(MessengerIcon)}`} alt="messenger logo" styleName="messenger" />
              </Link>
            )}
            {socialShareLinks["telegram-url"] && (
              <Link
                aria-label="Telegram Link"
                href={socialShareLinks["telegram-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`${assetify(LauncherIcon)}`} alt="launcher logo" styleName="launcher" />
              </Link>
            )}
            {socialShareLinks["whatsapp-url"] && (
              <Link
                aria-label="Whatsapp Link"
                href={socialShareLinks["whatsapp-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <WatsAppIcon />
              </Link>
            )}
            {socialShareLinks["email-url"] && (
              <Link
                aria-label="Email Link"
                href={socialShareLinks["email-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Email />
              </Link>
            )}
            {socialShareLinks["youtube-url"] && (
              <Link
                aria-label="Youtube Link"
                href={socialShareLinks["youtube-url"]}
                className="youtube-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube />
              </Link>
            )}
            {socialShareLinks["instagram-url"] && (
              <Link
                aria-label="Instagram Link"
                href={socialShareLinks["instagram-url"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram color1="#eee" color2="#121212" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  isDesktop: bool,
  toggleVerticalMenubar: func,
  hamburgerMenu: array,
  domainSlug: string,
  lang: string,
  socialLinks: object,
  customSocialLinks: object,
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

export default connect(mapStateToProps, null)(VerticalMenubar);
